import React, { useState } from "react";
import "./StaffLogin.css";
import axiosConfig from "../../Service/axiosConfig";
import { useNavigate } from "react-router-dom";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";

const StaffLogin = () => {
    const navigate = useNavigate();
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [data, setData] = useState({
        mobileno: "",
        password: "",
    });

    const handleInput = (e) => {
        const { name, value } = e.target;
        setData((prev) => ({ ...prev, [name]: value }));
        if (error) setError("");
    };

    const getErrorMessage = (err) => {
        const payload = err?.response?.data;
        if (!payload) return "Unable to sign in. Please try again.";
        return (
            payload.error ||
            payload.detail ||
            payload.message ||
            "Invalid email/phone or password."
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const username = data.mobileno.trim();
        const password = data.password;

        if (!username) {
            setError("Email or phone number is required.");
            return;
        }
        if (!password) {
            setError("Password is required.");
            return;
        }

        setLoading(true);
        setError("");
        try {
            const formData = new FormData();
            formData.append("username", username);
            formData.append("password", password);
            formData.append("is_admin", true);
            const res = await axiosConfig.post("/accounts/api/login/", formData);
            sessionStorage.setItem("token", res.data.token);
            localStorage.setItem("permissions", JSON.stringify(res.data.permissions));
            localStorage.setItem("user_data", JSON.stringify(res.data.user));
            navigate("/dashboard/users");
        } catch (err) {
            setError(getErrorMessage(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="staff-login-page">
            <div className="staff-login-shell">
                <aside className="staff-login-brand">
                    <img
                        className="staff-login-logo"
                        src={require("../DashboardLayout/images/icclogo.webp")}
                        alt="India Casting Club"
                    />
                    <p className="staff-login-kicker">Admin dashboard</p>
                    <h1>India Casting Club</h1>
                    <p className="staff-login-tagline">
                        Sign in to manage artists, auditions, subscriptions, and day-to-day operations.
                    </p>
                </aside>
                <section className="staff-login-panel">
                    <div className="staff-login-card">
                        <h2>Sign in</h2>
                        <p className="staff-login-subtitle">Use your staff email or phone number.</p>
                        {error ? (
                            <div className="staff-login-error" role="alert">
                                {error}
                            </div>
                        ) : null}
                        <form onSubmit={handleSubmit} noValidate>
                            <div className="form-group">
                                <label htmlFor="staff-login-username">Email or phone</label>
                                <input
                                    id="staff-login-username"
                                    type="text"
                                    className="form-control"
                                    placeholder="Email address or phone number"
                                    name="mobileno"
                                    value={data.mobileno}
                                    onChange={handleInput}
                                    autoComplete="username"
                                    autoFocus
                                    disabled={loading}
                                />
                            </div>
                            <div className="form-group has-icon">
                                <label htmlFor="staff-login-password">Password</label>
                                <input
                                    id="staff-login-password"
                                    type={visible ? "text" : "password"}
                                    className="form-control"
                                    placeholder="Enter password"
                                    name="password"
                                    value={data.password}
                                    onChange={handleInput}
                                    autoComplete="current-password"
                                    disabled={loading}
                                />
                                <button
                                    type="button"
                                    className="staff-login-eye"
                                    onClick={() => setVisible((prev) => !prev)}
                                    aria-label={visible ? "Hide password" : "Show password"}
                                    tabIndex={-1}
                                >
                                    {visible ? <MdVisibilityOff size={20} /> : <MdVisibility size={20} />}
                                </button>
                            </div>
                            <button
                                type="submit"
                                className="btn staff-login-submit"
                                disabled={loading}
                            >
                                {loading ? "Signing in..." : "Sign in"}
                            </button>
                        </form>
                        <p className="staff-login-copy">
                            &copy; {new Date().getFullYear()} India Casting Club. All rights reserved.
                        </p>
                    </div>
                </section>
            </div>
        </div>
    );
};

export { StaffLogin };
